import { types as t } from 'mobx-state-tree';

import { Translation } from 'models/ui';

export const WorkType = t.model('WorkType', {
  id: t.number,
  translations: t.array(Translation),
});
